import { configureStore } from '@reduxjs/toolkit';
import userReducer from "./user";
import seasonsReducer from "./seasons";
import shopReducer from "./shop";

export default configureStore({
    reducer: {
        user: userReducer,
        seasons: seasonsReducer,
        shop: shopReducer,
    }
});
